// pages/Unauthorized.jsx
export default function Unauthorized() {
  return <h2>🚫 403 - You are not authorized to view this page.</h2>;
}